module.exports = __webpack_public_path__ + "static/media/icon-calls-white.e4622cbd.svg";